import React from "react";
import "./nav.css";
import { Link } from "react-router-dom";

const Nav = () => {
  return (
    <>
      <div style={{ height: "56px" }}>
        <div className="navbarContainer">
          <div className="navMenu">
            <Link to="/dashboard">
              <img src="./images/pristinePvLogo.jpg" alt="logoIcon"></img>
            </Link>
          </div>
          <div className="navIcons">
            <div className="avatar">
              <div className="ellipse2"></div>
              <h6> IH </h6>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Nav;
